import { css, keyframes, styled } from 'styled-components';

import { device } from '@/styles/helpers';

export const movingBlinkAnimation = keyframes`
  0% {
    left: -40px;
  }
  100% {
    left: calc(100% + 40px);
  }
`;

export interface IScCTAButton {
  background?: string;
  color?: string;
  borderRadius?: string;
  movingBlink?: boolean;
}

export const ScCTAButton = styled.button<IScCTAButton>`
  position: relative;
  display: grid;
  place-items: center;
  width: 320px;
  height: 48px;
  padding-inline: 16px;
  border-radius: ${({ borderRadius }) => borderRadius};
  background-color: ${({ background }) => background};
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  color: ${({ color }) => color};
  cursor: pointer;
  transition: opacity 0.3s ease-in-out;
  margin-inline: auto;
  z-index: 0;
  overflow: hidden;

  ${({ movingBlink }) =>
    movingBlink &&
    css`
      &::after {
        content: '';
        position: absolute;
        height: 150%;
        width: 2px;
        background-color: #fff;
        pointer-events: none;
        left: -40px;
        top: -10px;
        transition: 1s ease;
        transform: rotate(45deg);
        box-shadow:
          0 0 12px 6px #fff,
          0 0 12px 8px hsla(0, 0%, 100%, 0.6),
          0 0 16px 12px hsla(0, 0%, 100%, 0.2);
        animation: ${movingBlinkAnimation} 4s cubic-bezier(0.28, 1, 0.32, 1)
          infinite;
      }
    `}

  @media (${device.mobile}) {
    width: 100%;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

  @media (hover: hover) {
    &:not(:disabled):hover {
      opacity: 0.8;
    }
  }
`;
